<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Name" />

              <select-input v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full" :label="__('Department')">
                  <option :value="null"></option>
                  <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>

          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!category.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Category</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Category</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/vue3'
import SelectInput from "../../Shared/SelectInput.vue";

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
      Link,
      Head,
  },
  layout: Layout,
  props: {
    title: String,
    category: Object,
    departments: { required: false },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.category.name,
          color: this.category.color,
          department_id: this.category.department_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('categories.update', this.category.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('categories.destroy', this.category.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this category?')) {
        this.$inertia.put(this.route('categories.restore', this.category.id))
      }
    },
  },
}
</script>
